import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Toaster } from 'sonner';
import { Header } from './Header';
import { Footer } from './Footer';
export function Layout() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return <div className="flex min-h-screen w-full flex-col bg-ink text-white" data-id="element-146" data-mp="3053hrfkg5t84">
      <a href="#main" className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-50 focus:bg-white focus:px-4 focus:py-2 focus:text-ink" data-id="element-147" data-mp="353wl4f60s3uk">
        Skip to content
      </a>
      <Header data-id="element-148" data-mp="3f11b6q2zkjgn" />
      <main id="main" className="flex-1" data-id="element-149" data-mp="3f2m3e91tvqbc">
        <Outlet data-id="element-150" data-mp="3ezgbyn5q8ccg" />
      </main>
      <Footer showQuickLinks={pathname !== '/'} data-id="element-151" data-mp="3j2w8ljhsqcp5" />
      <Toaster theme="dark" position="bottom-right" toastOptions={{
      style: {
        borderRadius: 0,
        background: '#161616',
        border: '1px solid #3a3a3a'
      }
    }} data-id="element-152" data-mp="3j2mkk1gbafm3" />
    </div>;
}